import { AppConfig } from '@aipb/env/util';
import { isUndefined } from '@aipb/util/other';
import { PersonalContentEnv } from './personal-content.env';

export class PersonalContentConfig extends AppConfig<PersonalContentEnv> {
  get top_level_collection_ui(): boolean {
    // @ts-expect-error foo
    return isUndefined(this.config.top_level_collection_ui) ? true : this.config.top_level_collection_ui;
  }

  get hideDidacticCollections(): boolean {
    // @ts-expect-error foo
    return isUndefined(this.config.hideDidacticCollections) ? false : this.config.hideDidacticCollections;
  }
}
